import React from 'react'

import './message-content-card.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    footer: React.ReactNode
  }
>

const MessageContentCard = ({className, children, footer, ...props}: Props) => (
  <div {...props} className={cn('MessageContentCard', {}, className)}>
    <div className="MessageContentCard__content">{children}</div>
    <div className="MessageContentCard__footer">{footer}</div>
  </div>
)

export default MessageContentCard
